import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getPayInOutSummary } from "../services/DashBoardApiService";

// Thunk to fetch Pay In / Out Summary
export const fetchPayInOutSummary = createAsyncThunk(
  "payinout/fetchPayInOutSummary",
  async ({ branch, StartingDate, EndingDate }) => {
    const data = await getPayInOutSummary(branch, StartingDate, EndingDate);
    return data; // Should return: { payIn: number, payOut: number }
  }
);

// Slice
const payInOutSlice = createSlice({
  name: "payinout",
  initialState: {
    payIn: 0,
    payOut: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPayInOutSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPayInOutSummary.fulfilled, (state, action) => {
        state.payIn = action.payload.payIn;
        state.payOut = action.payload.payOut;
        state.loading = false;
      })
      .addCase(fetchPayInOutSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default payInOutSlice.reducer;
